<!--ZjwResource:结构化资源 - 试题 2020/11/12 18:06:41 YuAng-->

<template>
  <iframe id="iframe_zjw" :src="url" frameborder="0" width="100%" height="100%">
  </iframe>
</template>
<script>
export default {
  name: 'ZjwResource',
  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data() {
    // 新增试题库应用，对接组卷网定制版2
    const route = process.env.VUE_APP_URL_STK + '/index.html#/source/stk'
    return {
      url: process.env.VUE_APP_URL_ZU_JUAN + '/customjump.aspx?_m=' + encodeURIComponent(route)
    }
  },
  created() {
    // 处理来自试题库定制域名详情页的链接域名不是e课堂域名的情况
    if (location.href.indexOf(process.env.VUE_APP_URL_STK) !== -1) {
      const url = location.href.replace(location.origin, process.env.VUE_APP_SITE)
      window.open(url, '_self')
    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler: function () {
        let path = encodeURIComponent(process.env.VUE_APP_URL_STK + '/index.html#/source/stk')
        if (location.href.indexOf('?') !== -1) {
          const paths = location.href.split('?')
          path = path + '&' + paths[1]
        }
        this.url = process.env.VUE_APP_URL_ZU_JUAN + '/customjump.aspx?_m=' + path
      }
    }
  }
}
</script>

<style scoped>
#iframe_zjw {
  min-height: calc(100vh - 126px);
}
</style>